import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { Tooltip } from '../../components/tooltip/index';

export type StakeholderRowProps = {
  email: string;
  fullName: string;
  isMobile?: boolean;
  isSelected: boolean;
  onClick: () => void;
};

export const StakeholderRow: FC<StakeholderRowProps> = ({
  email,
  fullName,
  isMobile,
  isSelected,
  onClick,
}) => (
  <div
    className={twMerge(
      'flex w-full cursor-pointer items-center gap-3 overflow-x-hidden p-4',
      isSelected && 'bg-brand-50',
      isMobile && 'p-2',
    )}
    onClick={onClick}
  >
    <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-brand-100">
      {fullName[0]}
    </div>
    <div className="flex shrink-0 flex-col">
      <Tooltip childrenWrapperClassName="w-[120px]" content={fullName}>
        <span className="cursor-pointer truncate text-sm font-[450] text-gray-700">{fullName}</span>
      </Tooltip>
      <Tooltip childrenWrapperClassName="w-[120px]" content={email}>
        <span className="cursor-pointer truncate text-label-sm font-medium text-gray-500">
          {email}
        </span>
      </Tooltip>
    </div>
  </div>
);
